import { TextField } from '@material-ui/core'

export default function FieldsNumber({
  classes,
  field,
  handleInput,
  formSelected
}) {
  return(
    <div className={classes.body__fields_number} >
      <TextField
        type='number'
        variant='outlined'
        label={field.summary_title}
        onChange={evt => handleInput(field.field_id, evt.target.value)}
        required={formSelected.mandatory}
        className={classes.body__fields_numberItem}
      />
    </div>
  )
}